import { ContentComponent } from "components/flexComponents/Content/factory/ContentComponent";
import { EditorialFlexModule } from "typings/microserviceModels/content-flex-module";
import { ContentFlexComponent } from "components/flexComponents/Content/typings";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";

/**
 * Abstract extension of ContentComponent that holds editorial specific fields and implements some of the functions that behave the same for most editorials.
 */
export abstract class EditorialBase extends ContentComponent {
  public readonly editorial: EditorialFlexModule;
  public readonly contentPurpose?: string;

  protected constructor(editorial: ContentFlexComponent) {
    super(editorial);
    this.editorial = editorial.model as EditorialFlexModule;
    this.contentPurpose = this.editorial.contentPurpose;
    this.keyHelper = new ItemKeyHelper("editorial");
  }

  public shouldRender = (): boolean =>
    this.flexComponent !== null && this.editorial && this.editorial.items && !(this.editorial.items.length < 1);

  public getId = (): string => this.id;

  public getEditorialItemClassName = (): string => "Editorial all-cell-1-1 uitk-cell all-y-padding-three";
}

export default EditorialBase;
